import styled from 'styled-components'

export const Card = styled.div<{ selected: boolean }>`
  display: flex;
  min-width: 110px;
  max-width: 110px;
  height: 36px;
  align-items: center;
  justify-content: center;
  color: ${({ selected }) => (selected ? '#000000' : 'rgba(0, 0, 0, 0.35)')};
  transition: background-color 1s, box-shadow 1s, color 0.3s;
  position: relative;
  border-radius: 7px;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  cursor: ${({ selected }) => (selected ? 'default' : 'pointer')};
  text-align: center;
  z-index: 1;
`
